import { render, staticRenderFns } from "./expansion-panel-faq.vue?vue&type=template&id=3eb18e9b&scoped=true&"
import script from "./expansion-panel-faq.vue?vue&type=script&lang=js&"
export * from "./expansion-panel-faq.vue?vue&type=script&lang=js&"
import style0 from "./expansion-panel-faq.vue?vue&type=style&index=0&id=3eb18e9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb18e9b",
  null
  
)

export default component.exports